import { render, staticRenderFns } from "./stepper2.vue?vue&type=template&id=71189167&scoped=true"
import script from "./stepper2.vue?vue&type=script&lang=js"
export * from "./stepper2.vue?vue&type=script&lang=js"
import style0 from "./stepper2.vue?vue&type=style&index=0&id=71189167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71189167",
  null
  
)

export default component.exports